"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../constants");
var types_1 = require("../types");
function getSportsBySportType(sports, sportType) {
    switch (sportType) {
        case constants_1.SportType.Esport: {
            return sports.filter(function (sport) {
                return sport.tags.includes(types_1.GQL.SportTag.ESPORT);
            });
        }
        case constants_1.SportType.Classic: {
            return sports.filter(function (sport) {
                return sport.tags.includes(types_1.GQL.SportTag.CLASSIC);
            });
        }
        case constants_1.SportType.Mix:
        default: {
            return sports;
        }
    }
}
exports.default = getSportsBySportType;
//# sourceMappingURL=getSportsBySportType.js.map